import { useHistory } from 'react-router-dom';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import StackingButtons from '../../common/components/StackingButtons';
import TranslatedSpan from '../../common/components/TranslatedSpan';
import translate from '../../common/functions/translate';

interface DisplayAccountInfoProps {
    userName: string
    createdAt: string
}

export default function DisplayAccountInfo(props: DisplayAccountInfoProps) {
    const history = useHistory();

    const getGetPasswordButton = () => {
        return <>
            <Button
                onClick={() => history.push('/forgot-password')}
            >
                <TranslatedSpan english={'get_password'}/>
            </Button>
        </>;
    };

    const getReturnToLoginButton = () => {
        return <>
            <Button
                variation={'solid'}
                onClick={() => history.push('/login')}
            >
                <TranslatedSpan english={'return_to_log_in'}/>
            </Button>
        </>;
    };

    return (
        <Div isContainer={true}>
            <Div isRow>
                <Div cols={12} paddingBottom={4}>
                    <H1>
                        {translate('you_currently_have_account')}
                    </H1>
                </Div>
            </Div>
            <Div>
                {translate('your_username_is')} <span className='ds-u-font-weight--semibold'>{props.userName}</span>
                <span className='unselectable-full-stop'></span>
            </Div>
            <Div paddingTop={3}>
                {`${translate('your_account_created_on')} ${props.createdAt}.`}
            </Div>
            <StackingButtons
                button1={getReturnToLoginButton()}
                button2={getGetPasswordButton()}
            />
        </Div>
    );
}
